import type { RxJsonSchema } from 'rxdb';
import type { SyncMetaDocType } from '../types/sync-meta';

export const syncMetaSchema: RxJsonSchema<SyncMetaDocType> = {
  version: 1,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    collectionName: { type: 'string', maxLength: 50 },
    lastSyncAt: { type: 'string' },
    lastCheckpoint: { type: 'string' },
    status: { type: 'string', enum: ['idle', 'syncing', 'error'], default: 'idle' },
    errorMessage: { type: 'string', maxLength: 1000 },
    recordCount: { type: 'number', default: 0 },
  },
  required: ['id', 'collectionName'],
  indexes: ['collectionName'],
};

export const syncMetaMigrationStrategies = {
  1: (oldDoc: any) => {
    return {
      id: oldDoc.id,
      collectionName: oldDoc.collection || 'global',
      lastSyncAt: oldDoc.lastSyncAt || null,
      lastCheckpoint: oldDoc.lastCheckpoint || null,
      status: oldDoc.status || 'idle',
      errorMessage: oldDoc.errorMessage || null,
      recordCount: oldDoc.recordCount || 0,
    };
  },
};
